import 'css-chunksrc/client/scenes/constrainElement/startStartForm/styles.scss';export default {
  "form": "_form_1r66d_1"
};